"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAccountPersonalDataResponseToVisitorDetails = void 0;
const mapAccountPersonalDataResponseToVisitorDetails = (personalData) => {
    if (!personalData) {
        return null;
    }
    return {
        fullName: personalData.firstName || personalData.lastName
            ? `${personalData.firstName} ${personalData.lastName}`.trim()
            : undefined,
        emailAddress: personalData.email || undefined,
        phoneNumber: personalData.phone,
    };
};
exports.mapAccountPersonalDataResponseToVisitorDetails = mapAccountPersonalDataResponseToVisitorDetails;
//# sourceMappingURL=fdr-chat.mappers.js.map